module.exports = __webpack_public_path__ + "static/media/usa-today.e9b8db7f.svg";